import {useEffect} from "react";
import {useDispatch, useSelector} from "react-redux";
import {tryLoadUsers} from "../../../redux/slices/manageUserSlice";
import CustomTableItemLoader from "../../../components/CustomTableItemLoader";
import ManageUserTableItem from "./ManageUserTableItem";
import {NORMAL_USERS, TABLE_DISPLAY_MODE_FEATURES} from "../constants";
import ManageUserTableFeatureItem from "./ManageUserTableFeatureItem";


export default function ManageUserTable() {

  const selectedTab = useSelector((state) => state.manageUser.selectedTab);

  const currentPage = useSelector((state) => state.manageUser[selectedTab].meta.page);


  const {
    loading = false, init = false, data: users = [], error = ""

  } = useSelector((state) => state.manageUser[selectedTab].pageData[currentPage]) ?? {};

  const dispatch = useDispatch();


  useEffect(() => {
    if (!init && !loading && !error)
      dispatch(tryLoadUsers());
  }, [init, loading, error]);


  return (
    <>
      {
        init && !!users.length ? <tbody>
          {/*{*/}
          {/*  users.map((user) => {*/}
          {/*    return <ManageUserTableItem user={user} key={user.id}/>;*/}
          {/*  })*/}
          {/*}*/}
          <UsersTableModeContent users={users}/>
          </tbody> :
          <CustomTableItemLoader colSpan={6} loading={loading} error={error} isEmpty={init && !users.length} count={6}
                                 retry={() => dispatch(tryLoadUsers())}/>
      }

    </>
  );
}

const UsersTableModeContent = ({users}) => {

  const displayMode = useSelector((state) => state.manageUser.displayMode);
  const selectedTab = useSelector((state) => state.manageUser.selectedTab);

  const displayFeatures = displayMode === TABLE_DISPLAY_MODE_FEATURES && selectedTab === NORMAL_USERS;

  return (
    <>
      {
        displayFeatures ? <FeaturesContent users={users}/> :

          users.map((user) => {
            return <ManageUserTableItem user={user} key={user.id}/>;
          })
      }
    </>

  );
};

const FeaturesContent = ({users}) => {

  const features = useSelector((state) => state.manageUser.features.data);

  return (
    <>
      {
        features.map((feature) => {
          return <ManageUserTableFeatureItem users={users} key={feature.id} feature={feature}/>;
        })
      }
    </>

  );
};